export const shell = {
  nav: {
    groupWork: "Work",
    groupGrow: "Grow",
    groupAi: "AI",
    home: "Home",
    inbox: "Inbox",
    approvals: "Approvals",
    content: "Content",
    calendar: "Calendar",
    posts: "Posts",
    compose: "Create post",
    automation: "Rules",
    rules: "Rules",
    runs: "Automation log",
    agents: "AI agents",
    analytics: "Analytics",
    dashboards: "Dashboards",
    studio: "AI Studio",
    assistant: "Assistant",
    contacts: "Contacts",
    people: "People",
    jobs: "Jobs",
    settings: "Settings",
    more: "More",
    admin: "Admin",
  },
  accounts: {
    all: "All accounts",
    allHint: "Every connected channel",
    switch: "Switch account",
    connectMore: "Connect a channel",
    followers: "{{n}} followers",
    reconnect: "Reconnect @{{user}}",
  },
  topbar: {
    search: "Search or jump to…",
    approvalsWaiting_one: "{{count}} waiting for approval",
    approvalsWaiting_other: "{{count}} waiting for approval",
    live: "Live",
    liveConnecting: "Connecting…",
    liveReconnecting: "Reconnecting…",
    liveOffline: "Offline",
    liveIdle: "Not connected",
    liveHint: "Live updates: new comments and messages appear without refreshing.",
    theme: "Theme",
    themeSystem: "System",
    themeLight: "Light",
    themeDark: "Dark",
    language: "Language",
    switchLang: "العربية",
    profile: "Profile",
    settings: "Settings",
    shortcuts: "Keyboard shortcuts",
    signOut: "Sign out",
    signedInAs: "Signed in as",
    mockMode: "Demo data",
    mockHint: "You're exploring with demo data. Nothing is sent to Instagram.",
  },
  notifications: {
    title: "Notifications",
    empty: "You're all caught up",
    emptyHint: "Approvals, crisis alerts and failed posts will show up here.",
    markAllRead: "Mark all read",
    newComment: "New comment from @{{user}}",
  },
  palette: {
    placeholder: "Type a command or search…",
    empty: "No results",
    navigate: "Go to",
    actions: "Actions",
    recent: "Recent",
    preferences: "Preferences",
    newPost: "Create a post",
    newRule: "Create an automation rule",
    askAssistant: "Ask the assistant",
    voiceMode: "Talk to the assistant (voice)",
    toggleTheme: "Toggle dark mode",
    toggleLang: "Switch language to Arabic",
    openShortcuts: "Show keyboard shortcuts",
    signOut: "Sign out",
    inboxNegative: "Inbox: negative comments",
    inboxUnassigned: "Inbox: unassigned",
  },
  shortcuts: {
    title: "Keyboard shortcuts",
    global: "Everywhere",
    inbox: "Inbox",
    approvals: "Approvals",
    palette: "Command palette",
    help: "Show this sheet",
    goHome: "Go to Home",
    goInbox: "Go to Inbox",
    goApprovals: "Go to Approvals",
    goCalendar: "Go to Calendar",
    goAutomation: "Go to Automation",
    goAnalytics: "Go to Analytics",
    next: "Next item",
    prev: "Previous item",
    done: "Done",
    reply: "Reply",
    hide: "Hide / unhide",
    assign: "Assign to me",
    search: "Search",
    select: "Select item",
    approve: "Approve",
    reject: "Reject",
    editDraft: "Edit draft",
    then: "then",
  },
  crisis: {
    title: "Negative comments are spiking",
    body_one: "{{count}} negative comment in the last 24 hours, {{pct}} above normal.",
    body_other: "{{count}} negative comments in the last 24 hours, {{pct}} above normal.",
    action: "Review now",
  },
  batch: {
    running: "Applying to {{done}} of {{total}}…",
    done: "Done: {{done}} of {{total}}",
    failed: "{{failed}} failed",
    opFailed: "It didn't go through. Please try again.",
    opCancelled: "Cancelled",
    cancel: "Cancel",
  },
  admin: {
    title: "Platform admin",
    description: "Malfak staff tools. This area is being built; the API for it isn't ready yet.",
    badge: "Staff only",
    soon: "Coming soon",
    sections: {
      orgs: "Organizations & plans",
      users: "Users & sessions",
      channels: "Channel health & webhooks",
      ai: "AI usage & cost",
      flags: "Feature flags",
      audit: "Audit log",
    },
  },
};
